export const ContextMode = Object.freeze({
  BAR: 'BAR',
  OVERLAY: 'OVERLAY',
});
